import { HelmetProvider } from '@dr.pogodin/react-helmet';
import { config } from '@iheartjane/config';
import { defaultQueryClientConfig } from '@iheartjane/data-access/react-query';
import { asyncFlagProvider } from '@iheartjane/feature-flags';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createRoot } from 'react-dom/client';

import { bootstrap } from '@jane/monolith/bootstrap';
import { ConfigureStore } from '@jane/monolith/customer/configureStore';
import { ErrorBoundary } from '@jane/shared-ecomm/components';
import { EcommAppProvider } from '@jane/shared/providers';

import { App } from './App';

// eslint-disable-next-line @iheartjane/workspace/no-dom-globals-in-module-scope
const container = document.getElementById('app');
if (!container) {
  throw new Error('Root element not found');
}
const root = createRoot(container);

(async () => {
  const FlagProvider = await asyncFlagProvider({
    application: { id: 'boost', version: config.appVersion },
    baseUrl: config.launchDarklyBaseUrl,
    clientSideID: config.launchDarklyClientID,
    eventsUrl: config.launchDarklyEventsUrl,
    streamUrl: config.launchDarklyStreamUrl,
  });
  await bootstrap();
  const queryClient = new QueryClient(defaultQueryClientConfig);
  root.render(
    <ErrorBoundary withReeferThemeProvider>
      <EcommAppProvider appMode="framelessEmbed">
        <FlagProvider>
          <HelmetProvider>
            <ConfigureStore>
              <QueryClientProvider client={queryClient}>
                <App />
              </QueryClientProvider>
            </ConfigureStore>
          </HelmetProvider>
        </FlagProvider>
      </EcommAppProvider>
    </ErrorBoundary>
  );
})();
